module.exports = __webpack_public_path__ + "static/media/AMDM.e4976ea4.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/AMDM.JPG
// module id = 1298
// module chunks = 1